.unschedule-button {
    padding: 0;
}
